export const SocketEvents = {
    connection: 'connection',
    uploadedForecastDelta: 'uploadedForecastDelta',
    uploadedLocationDelta: 'uploadedLocationDelta',
    createdBookingDelta: 'createdBookingDelta',
    postedEvent: 'postedEvent',
};
